<template>
  <div>
    <v-tabs v-model="tab_ativo" centered>
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#tab-1">
        <v-icon left>mdi-chart-bell-curve</v-icon>
        Curvas criticidade
      </v-tab>
    </v-tabs>

    <div class="mx-1">
      <div class="d-flex align-center py-2 pl-1 pr-2">
        <v-icon left size="22">mdi-format-list-bulleted</v-icon>
        <span class="font-18">Lista de importações</span>

        <v-spacer />

        <DialogImportacao @importacao-com-sucesso="atualizar_grid_count++" />
      </div>

      <Grid class="pl-1" :atualizar_grid_count="atualizar_grid_count" />
    </div>
  </div>
</template>

<script>
import Grid from '@/components/Parametrizacao/CurvasCriticidade/Grid'
import DialogImportacao from "@/components/Parametrizacao/CurvasCriticidade/DialogImportacao";

export default {
  name: "Index",
  components: {
    DialogImportacao,
    Grid
  },
  data: () => ({
    tab_ativo: null,
    atualizar_grid_count: 0,
  })
}
</script>

<style scoped>

</style>
